module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "fs-status-card my-5",
    attrs: {
      "flat": "",
      "outlined": ""
    }
  }, [_c('div', {
    staticClass: "fs-status-title"
  }, [_vm._v(_vm._s(_vm.work.deviceName || _vm.work.name || '—'))]), _vm._v(" "), _c('div', {
    staticClass: "fs-status-chip",
    class: _vm.statusClass
  }, [_vm._v("\n    " + _vm._s(_vm.statusLabel) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "fs-status-row mt-3"
  }, [_c('v-icon', {
    attrs: {
      "size": "16",
      "color": "#193546"
    }
  }, [_vm._v("mdi-account-hard-hat-outline")]), _vm._v(" "), _c('span', {
    staticClass: "fs-status-text"
  }, [_vm._v(_vm._s(_vm.work.userDisplay || '—'))])], 1), _vm._v(" "), _c('div', {
    staticClass: "fs-status-row"
  }, [_c('v-icon', {
    attrs: {
      "size": "16",
      "color": "#193546"
    }
  }, [_vm._v("mdi-map-marker-outline")]), _vm._v(" "), _c('span', {
    staticClass: "fs-status-text"
  }, [_vm._v(_vm._s(_vm.work.coordinates || '—'))])], 1), _vm._v(" "), _c('div', {
    staticClass: "fs-status-row"
  }, [_c('v-icon', {
    attrs: {
      "size": "16",
      "color": _vm.work.hasPluviometricChart ? '#0098E1' : '#8FA3AD'
    }
  }, [_vm._v("mdi-file-document-outline")]), _vm._v(" "), _c('span', {
    staticClass: "fs-status-text"
  }, [_vm._v(_vm._s(_vm.chartLabel))])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e79f980","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Audits/FieldSurveyStatusCard.vue
// module id = 1713
// module chunks = 0